import React, { useEffect, useState } from 'react';
import {
  AppInput,
  AppInputNumber,
  AppRemixIcon,
  AppSingleSelect,
  AppNoInfo,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import Translator from '../../../../../../components/helpers/Translator';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';

const AccionaPenaltyRiskTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const poLevel3 = useSelector(
    (s) => s.currentPage?.plantObligationLevels?.level3
  );
  const permissions = useSelector((s) => s.module[moduleBridgeHex].permissions);
  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex].userBridge
  );
  const [data, setData] = useState();
  const [options3] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.low"
        />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.medium"
        />
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.high"
        />
      ),
      value: 3,
    },
  ]);

  const [options5] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.low"
        />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.medium-low"
        />
      ),
      value: 2,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.medium"
        />
      ),
      value: 3,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.high-medium"
        />
      ),
      value: 4,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="acciona.penalty.risk.classification.high"
        />
      ),
      value: 5,
    },
  ]);
  const dispatch = useDispatch();

  // > LOAD DATA TAB
  const loadDataTab = async () => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_legalCompliance_accionaPenaltyRisk_tab"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      );
      return response.data;
    } catch (err) {}
  };

  useEffect(() => {
    loadDataTab().then((r) => {
      const initialValues = {
        code: r?.code,
        economic: r?.inherentImpact?.economic,
        reputational: r?.inherentImpact?.reputational,
        operational: r?.inherentImpact?.operational,
        inherentImpactTotal: r?.inherentImpact?.total,
        frequency: r?.inherentProbability?.frequency,
        reiteration: r?.inherentProbability?.reiteration,
        complexity: r?.inherentProbability?.complexity,
        imprudence: r?.inherentProbability?.imprudence,
        countryRisk: r?.inherentProbability?.countryRisk,
        countryWeight: r?.inherentProbability?.countryWeight,
        inherentProbabilityTotal: r?.inherentProbability?.total,
        automationLevel: r?.managementLevel?.automationLevel,
        nature: r?.managementLevel?.nature,
        controlSufficiency: r?.managementLevel?.controlSufficiency,
        managementLevelTotal: r?.managementLevel?.total,
        residualImpact: r?.vulnerability?.residualImpact,
        residualProbability: r?.vulnerability?.residualProbability,
      };
      setData(initialValues);
    });
  }, []);
  // < LOAD DATA TAB

  // > EDIT
  const handleEdit = async (values) => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_accionaPenaltyRisk_edit"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          values,
        }
      )
      .then((r) => {
        const initialValues = {
          economic: r.data?.inherentImpact?.economic,
          reputational: r.data?.inherentImpact?.reputational,
          operational: r.data?.inherentImpact?.operational,
          inherentImpactTotal: r.data?.inherentImpact?.total,
          frequency: r.data?.inherentProbability?.frequency,
          reiteration: r.data?.inherentProbability?.reiteration,
          complexity: r.data?.inherentProbability?.complexity,
          imprudence: r.data?.inherentProbability?.imprudence,
          countryRisk: r.data?.inherentProbability?.countryRisk,
          countryWeight: r.data?.inherentProbability?.countryWeight,
          inherentProbabilityTotal: r.data?.inherentProbability?.total,
          automationLevel: r.data?.managementLevel?.automationLevel,
          nature: r.data?.managementLevel?.nature,
          controlSufficiency: r.data?.managementLevel?.controlSufficiency,
          managementLevelTotal: r.data?.managementLevel?.total,
          residualImpact: r.data?.vulnerability?.residualImpact,
          residualProbability: r.data?.vulnerability?.residualProbability,
        };
        setData(initialValues);
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].accionaPenaltyRisk = {
          residualImpact: r.data?.vulnerability?.residualImpact,
          residualProbability: r.data?.vulnerability?.residualProbability,
        };
        dispatch(
          currentPageAction.change("plantObligationLevels", {
            level3: updatedLevel3,
          })
        );
      });
  };
  // < EDIT

  if (!data) return <AppNoInfo minHeight={300} />;

  return (
    <AccionaPenaltyRiskTabContainer>
      <Formik
        initialValues={data}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        onSubmit={handleEdit}
      >
        {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <AppInput
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="acciona.penalty.risk.code"
                      />
                    )}
                    value={values.code}
                    onChange={(v) => setFieldValue('code', v)}
                    icon={<AppRemixIcon icon="font-color" noVariants />}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Impacto inherente</h3>
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Económico"
                    value={values.economic}
                    onChange={(v) => setFieldValue('economic', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Reputacional"
                    value={values.reputational}
                    onChange={(v) => setFieldValue('reputational', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Operacional"
                    value={values.operational}
                    onChange={(v) => setFieldValue('operational', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Total"
                    value={values.inherentImpactTotal}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Probabilidad Inherente</h3>
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Frecuencia"
                    value={values.frequency}
                    onChange={(v) => setFieldValue('frequency', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Reiteración"
                    value={values.reiteration}
                    onChange={(v) => setFieldValue('reiteration', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Complejidad"
                    value={values.complexity}
                    onChange={(v) => setFieldValue('complexity', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Imprudencia"
                    value={values.imprudence}
                    onChange={(v) => setFieldValue('imprudence', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Riesgo país"
                    value={values.countryRisk}
                    onChange={(v) => setFieldValue('countryRisk', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options5}
                    title="Peso del país"
                    value={values.countryWeight}
                    onChange={(v) => setFieldValue('countryWeight', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Total"
                    value={values.inherentProbabilityTotal}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Nivel de Gestión</h3>
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Naturaleza"
                    value={values.nature}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Grado de automatización"
                    value={values.automationLevel}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={options3}
                    title="Suficiencia del control"
                    value={values.controlSufficiency}
                    onChange={(v) => setFieldValue('controlSufficiency', v)}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Total"
                    value={values.managementLevelTotal}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Vulnerabilidad</h3>
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Impacto Residual"
                    value={values.residualImpact}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    title="Probabilidad Residual"
                    value={values.residualProbability}
                    onChange={() => {}}
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-xs btn-success float-right"
                    disabled={isSubmitting}
                  >
                    Editar
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </AccionaPenaltyRiskTabContainer>
  );
};
export default AccionaPenaltyRiskTab;

const AccionaPenaltyRiskTabContainer = styled.div`
  height: 400px;
  overflow-y: auto;
`;
